import { fetchEventSource } from '@microsoft/fetch-event-source'
export const eventSource = config => {
  const ctrl = new AbortController()
  const resTemplate = {
    type: 'open',
    data: {},
    flag: ''
  }
  const headers = {
    // 'Content-Type': 'multipart/form-data;',
    ...config.headers
  }
  const formData = new FormData()
  Object.keys(config.data).forEach(key => {
    formData.append(key, config.data[key])
  })
  fetchEventSource(config.url, {
    method: config.method || 'GET',
    headers,
    body: formData,
    signal: ctrl.signal,
    openWhenHidden: true,
    onopen() {
      resTemplate.type = 'open'
      config.message(JSON.parse(JSON.stringify(resTemplate)))
    },
    onmessage(res) {
      resTemplate.type = 'message'
      const data = JSON.parse(res.data)
      resTemplate.data = data
      config.message(JSON.parse(JSON.stringify(resTemplate)))
    },
    onerror(err) {
      resTemplate.type = 'error'
      resTemplate.data = {}
      config.message(JSON.parse(JSON.stringify(resTemplate)))
      // ctrl.abort()
      throw err
    },
    onclose: () => {
      resTemplate.type = 'close'
      config.message(JSON.parse(JSON.stringify(resTemplate)))
    }
  })
  return ctrl
}
